<ion-label>
	<ion-radio-group>
		@for (option of this.optionGroup.articles; track option; let optionIndex = $index) {
			@if (!ifFilterVisible(option)) {
				<ion-item
					(click)="toggle(option)"
					[class.selected]="isOptionSelected(option)"
					[disabled]="isDisabled(option)"
					class="ion-text-wrap ion-no-padding"
					lines="none"
					mode="md"
				>
					@if (hasMultiple) {
						<div class="qty place-items-center" slot="end">
							<ion-fab-button
								(click)="decreaseOption(option)"
								[class.hidden]="count(option) <= 0"
								class="qty__btn"
								color="primary"
								size="small"
							>
								<span>-</span>
							</ion-fab-button>
							<span [class.zero]="count(option) <= 0" class="qty-number">{{ count(option) }}</span>
							<ion-fab-button
								(click)="increaseOption(option)"
								[class.hidden]="totalCount() >= optionGroup.limit"
								class="qty__btn"
								color="primary"
								size="small"
							>
								<span>+</span>
							</ion-fab-button>
						</div>
					}
					@if (getPrice(option, ot.STANDARD, preorderType) > 0) {
						<span class="price" slot="end">
							+{{ numberToCurrency(getPrice(option, ot.STANDARD, preorderType), currency) }}
						</span>
					}
					<!-- <ion-checkbox *ngIf="!hasMultiple" [ngModel]="isOptionSelected(option)"
                  [value]="option" slot="end"></ion-checkbox> -->
					@if (!hasMultiple) {
						<ion-toggle [ngModel]="isOptionSelected(option)" [value]="option" slot="end"></ion-toggle>
					}
					<ion-label>
						<div class="text_wrap">
							<span>
								{{ option.name | langObservable | async }}
								<!-- <ion-button
                *ngIf="isAllergens(option) || isAddit(option) || isHaveAnyValueMoreZero(option) || option?.info?.de?.length > 0"
                (click)="openInfoClick(option); $event.stopPropagation()"
                class="content-only"
                slot="end"
                >
                <ion-icon slot="icon-only" src="/assets/topgolf/info.svg"></ion-icon>
              </ion-button> -->
							</span>
						</div>
					</ion-label>
				</ion-item>
			}
		}
	</ion-radio-group>
</ion-label>
